export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-yahoo-04f4aac02e2226d3e59febf4d3d07905.svg";